/* eslint-disable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import userLabels from "../labels/users_en.json";
import dayjs from "dayjs";
import { getAllUser } from "../actions/userAction";
import EditActiveUser from "./EditActiveUser";

const ActiveUserTable = ({hasUpdateMasterPermission}) => {
  const dispatch = useDispatch();
  const { getActiveUser } = useSelector(
    (state) => state.userManagementReducer,
    shallowEqual
  );
  let [showModal, setShowModal] = useState(false);
  let [editEle, setEditEle] = useState({});

  const handleEditActiveUser = (ele) => {
    setShowModal(true);
    setEditEle(ele);
  };

  useEffect(() => {
    dispatch(getAllUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div
      className="border border-light table-responsive user_management_table"
      style={{ textAlign: "center", padding: "20px" }}
    >
      <table className="table"> 
        <thead className="table-primary">
          <tr>
            {userLabels.activeUserHeaderContent.map((ele, index) => {
              return hasUpdateMasterPermission === false && ele === "" ?
                (
                  <th scope="col" key={index} style={{ display: "none" }}>
                    {ele}
                  </th>
                )
                :
                (
                  <th scope="col" key={index}>
                    {ele}
                  </th>
                )
            })}
          </tr>
        </thead>
        {/* <tbody style={{ fontSize: "12px" }}>
          {getActiveUser && getActiveUser.sort((a, b) => a.userOas.updatedAt < b.userOas.updatedAt ? - 1 : 1).reverse().map((ele, index) => {

            if (!ele.flgDeleted) {
              let rows = [
                <tr key={index}>
                  <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}>{ele.userOas.updatedAt ? dayjs(ele.userOas.updatedAt).format('DD/MM/YYYY h:mm A') : ""}</td>
                  <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}>{ele.userOas.firstName}</td>
                  <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}>{ele.userOas.lastName}</td>
                  <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}><i data-toggle="tooltip" title={`${ele.userOas.isEmailVerified ? "Veriﬁed" : "Not Veriﬁed"}`} className={`fa fa-check-circle ${ele.userOas.isEmailVerified ? "greenColor" : "redColor"}`} aria-hidden="true"></i> &nbsp;{ele.userOas.email}</td>
                  <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}><i title={`${ele.userOas.isMobileVerified ? "Veriﬁed" : "Not Veriﬁed"}`} className={`fa fa-check-circle ${ele.userOas.isMobileVerified ? "greenColor" : "redColor"}`} aria-hidden="true"></i> &nbsp;{ele.userOas.mobile}</td>
                  <td className="word-break">{ele.userOasDeptRoleList[0] && ele.userOasDeptRoleList[0].role.name}</td>
                  <td className="word-break">{ele.userOasDeptRoleList[0] && ele.userOasDeptRoleList[0].department.name}</td>

                  {hasUpdateDelUserPermission &&
                    <td className="word-break" rowSpan={ele.userOasDeptRoleList.length}>
                      <i style={{ fontSize: "15px", color: "#007bff", marginRight: "5px", cursor: 'pointer' }} data-toggle="tooltip" title="Edit User" className='fa fa-edit' aria-hidden="true" onClick={() => { handleEditActiveUser(ele) }}></i>
                    </td>
                  }
                  <i  style={{fontSize:"15px", color:"red"}} className='fa fa-trash' onClick={()=>{handleDeleteActiveUser()}}></i>

                </tr>
              ]
              ele.userOasDeptRoleList.slice(1).forEach((roleDept, index) => {
                rows.push(
                  <tr key={index}>
                    <td className="word-break">{roleDept.role.name}</td>
                    <td className="word-break">{roleDept.department.name}</td>
                  </tr>
                )
              }
              )
              return rows;
            }
          })
          }
        </tbody> */}
        <tbody style={{ fontSize: "12px" }}>
          {getActiveUser &&
            getActiveUser
              .filter((ele) => !ele.flgDeleted)
              .sort((a, b) =>
                a.userOas.updatedAt < b.userOas.updatedAt ? -1 : 1
              )
              .reverse()
              .map((ele, index) => {
                return ele.userOasDeptRoleList.map((roleDept, idx) => (
                  <tr key={`${ele.userOas.id}-${idx}`}>
                    {idx === 0 && (
                      <>
                        <td
                          className="word-break"
                          rowSpan={ele.userOasDeptRoleList.length}
                        >
                          {ele.userOas.updatedAt
                            ? dayjs(ele.userOas.updatedAt).format(
                              "DD/MM/YYYY h:mm A"
                            )
                            : ""}
                        </td>
                        <td
                          className="word-break"
                          rowSpan={ele.userOasDeptRoleList.length}
                        >
                          {ele.userOas.firstName}
                        </td>
                        <td
                          className="word-break"
                          rowSpan={ele.userOasDeptRoleList.length}
                        >
                          {ele.userOas.lastName}
                        </td>
                        <td
                          className="word-break left-align"
                          rowSpan={ele.userOasDeptRoleList.length}

                        >
                          <i
                            data-toggle="tooltip"
                            title={`${ele.userOas.isEmailVerified
                              ? "Verified"
                              : "Not Verified"
                              }`}
                            className={`fa fa-check-circle ${ele.userOas.isEmailVerified
                              ? "greenColor"
                              : "redColor"
                              }`}
                            aria-hidden="true"
                          ></i>{" "}
                          &nbsp;{ele.userOas.email}
                        </td>
                        <td
                          className="word-break"
                          rowSpan={ele.userOasDeptRoleList.length}
                        >
                          <i
                            title={`${ele.userOas.isMobileVerified
                              ? "Verified"
                              : "Not Verified"
                              }`}
                            className={`fa fa-check-circle ${ele.userOas.isMobileVerified
                              ? "greenColor"
                              : "redColor"
                              }`}
                            aria-hidden="true"
                          ></i>{" "}
                          &nbsp;{ele.userOas.mobile}
                        </td>
                      </>
                    )}
                    <td className="word-break left-align">{roleDept.role.name}</td>
                    <td className="word-break left-align">{roleDept.department.name}</td>
                    {hasUpdateMasterPermission && idx === 0 && (
                      <td
                        className="word-break"
                        rowSpan={ele.userOasDeptRoleList.length}
                      >
                        <i
                          style={{
                            fontSize: "15px",
                            color: "#007bff",
                            marginRight: "5px",
                            cursor: "pointer",
                          }}
                          data-toggle="tooltip"
                          title="Edit User"
                          className="fa fa-edit"
                          aria-hidden="true"
                          onClick={() => {
                            handleEditActiveUser(ele);
                          }}
                        ></i>
                      </td>
                    )}
                  </tr>
                ))
              })}
        </tbody>
      </table>
      <EditActiveUser
        showModal={showModal}
        setShowModal={setShowModal}
        header={"Edit User"}
        userData={editEle}
      />
      {/* <Modal show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }} backdrop='static'>
                <Modal.Header className="logout_heading">
                    <Modal.Title className="logout_title">Delete Active User</Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => { setShowDeleteModal(false) }}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                        <label>Are you sure you want to delete this User?</label> 
                  
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => { setShowDeleteModal(false) }}>Cancel</button>
                    <button className=" btn btn-primary custom_button "onClick={() => { comfirmDeleteUserModal() }} >Confirm</button>
                </Modal.Footer>
          </Modal> */}
    </div>
  );
};

export default ActiveUserTable;
